var unitsMixin = {
	data: function () {
		return {
			product: {
				dimensions: {
					unit: 'mm',
				},
			},
		};
	},
	methods: {
		/**
		 * Converts units
		 * @param {string} oldUnit The unit to convert from
		 * @param {string} event The form field and all its properties
		 */
		changeUnit: function (oldUnit, event) {
			const vm = this;

			const newUnit = event.target.value;

			vm.product.dimensions.unit = newUnit;

			const height = vm.$refs.height;
			const width = vm.$refs.width;
			const length = vm.$refs.length;
			const diameter = vm.$refs.diameter;

			var el = null;
			if (vm.elementExists(height)) {
				el = height;
				vm.displayDimensions.height = this.convert(Number(vm.displayDimensions.height), oldUnit, newUnit);
			}

			if (vm.elementExists(width)) {
				el = width;
				vm.displayDimensions.width = this.convert(Number(vm.displayDimensions.width), oldUnit, newUnit);
			}

			if (vm.elementExists(length)) {
				el = length;
				vm.displayDimensions.length = this.convert(Number(vm.displayDimensions.length), oldUnit, newUnit);
			}

			if (vm.elementExists(diameter)) {
				el = diameter;
				vm.displayDimensions.diameter = this.convert(Number(vm.displayDimensions.diameter), oldUnit, newUnit);
			}

			el.min = this.convert(Number(el.min), oldUnit, newUnit);
			el.max = this.convert(Number(el.max), oldUnit, newUnit);
		},
		convert: function (value, oldUnit, newUnit) {
			const vm = this;

			// Define conversion factors
			const conversionFactors = {
				mm: { cm: 0.1, meters: 0.001 },
				cm: { mm: 10, meters: 0.01 },
				meters: { mm: 1000, cm: 100 },
			};

			if (!conversionFactors[oldUnit] || !conversionFactors[oldUnit][newUnit]) {
				throw new Error('Invalid units provided');
			}

			const conversionFactor = conversionFactors[oldUnit][newUnit];
			const newValue = value * conversionFactor;

			return newValue;
		},
		decimalRounding: function (vm, el, value, shapeProperty) {
			if (vm.product.dimensions.unit == 'mm') {
				// remove any decimal if mm
				value = Math.round(value);

				el.value = value;
				el.dispatchEvent(new Event('input'));
				// save it to the product props
				vm.product.dimensions[shapeProperty] = value;
			} else {
				let zeros;
				// zeros: 10 = 1 decimal place, 100 = 2 etc
				if (vm.product.dimensions.unit == 'cm') {
					zeros = 10;

					// save it to the product props
					vm.product.dimensions[shapeProperty] = value * 10;
				} else {
					zeros = 1000;

					// save it to the product props
					vm.product.dimensions[shapeProperty] = value * 1000;
				}
				//check if decimal and if so round to X decimal place(s)
				if (!Number.isInteger(value)) {
					value = Math.round(value * zeros) / zeros;
					el.value = value;
					el.dispatchEvent(new Event('input'));
				}
			}
			// save it to the product props
			vm.displayDimensions[shapeProperty] = value;
		},
	},
	watch: {
		'displayDimensions.length': function (value) {
			const vm = this;
			let el = document.getElementById('length');
			if (value) {
				this.decimalRounding(vm, el, value, 'length');
			}
		},
		'displayDimensions.height': function (value) {
			const vm = this;
			let el = document.getElementById('height');
			if (value) {
				this.decimalRounding(vm, el, value, 'height');
			}
		},
		'displayDimensions.width': function (value) {
			const vm = this;
			let el = document.getElementById('width');
			if (value) {
				this.decimalRounding(vm, el, value, 'width');
			}
		},
		'displayDimensions.diameter': function (value) {
			const vm = this;
			let el = document.getElementById('diameter');
			if (value) {
				this.decimalRounding(vm, el, value, 'diameter');
			}
		},
		'product.dimensions.thickness': function (value) {
			const vm = this;
			vm.setMaxMinProperties(value.toString());
		},
		'product.dimensions.diameter': function (value) {
			const vm = this;
			const diameterElement = document.getElementById('diameter');
			if (diameterElement.tagName == 'SELECT') {
				vm.setMaxMinProperties(value.toString());
			}
		},
		'product.dimensions.tubeDiameter': function (value) {
			const vm = this;
			vm.setMaxMinProperties(value.toString());
		},
	},
};
